import { render, staticRenderFns } from "./AddAdress.vue?vue&type=template&id=20dad014&scoped=true"
import script from "./AddAdress.vue?vue&type=script&lang=js"
export * from "./AddAdress.vue?vue&type=script&lang=js"
import style0 from "./AddAdress.vue?vue&type=style&index=0&id=20dad014&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dad014",
  null
  
)

export default component.exports